import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=3b3d1674"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b3d1674')) {
      api.createRecord('3b3d1674', component.options)
    } else {
      api.reload('3b3d1674', component.options)
    }
    module.hot.accept("./TheHeader.vue?vue&type=template&id=3b3d1674", function () {
      api.rerender('3b3d1674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/header/TheHeader.vue"
export default component.exports